import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c820b68"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "general-statistics"
}
const _hoisted_2 = ["title"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Média de avaliação")
], -1))
const _hoisted_4 = ["title"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Treinamentos liberados")
], -1))
const _hoisted_6 = ["title"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Treinamentos realizados")
], -1))
const _hoisted_8 = ["title"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Treinamentos em andamento")
], -1))
const _hoisted_10 = ["title"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode(" Horas "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" assistidas ")
  ])
], -1))
const _hoisted_12 = ["title"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Acessos", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.generalStatistics)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "block",
          title: _ctx.generalStatistics.average
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.generalStatistics.average), 1),
          _hoisted_3
        ], 8, _hoisted_2),
        _createElementVNode("div", {
          class: "block",
          title: _ctx.generalStatistics.releasedCourses
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.generalStatistics.releasedCourses), 1),
          _hoisted_5
        ], 8, _hoisted_4),
        _createElementVNode("div", {
          class: "block",
          title: _ctx.generalStatistics.coursesFinished
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.generalStatistics.coursesFinished), 1),
          _hoisted_7
        ], 8, _hoisted_6),
        _createElementVNode("div", {
          class: "block",
          title: _ctx.generalStatistics.coursesInProgress
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.generalStatistics.coursesInProgress), 1),
          _hoisted_9
        ], 8, _hoisted_8),
        _createElementVNode("div", {
          class: "block",
          title: _ctx.generalStatistics.hoursWatched
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.formattedDuration(_ctx.generalStatistics.hoursWatched)), 1),
          _hoisted_11
        ], 8, _hoisted_10),
        _createElementVNode("div", {
          class: "block",
          title: _ctx.generalStatistics.quantityAccessed
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.generalStatistics.quantityAccessed), 1),
          _hoisted_13
        ], 8, _hoisted_12)
      ]))
    : _createCommentVNode("", true)
}